<template>
    <div class="load-bag" v-if="showLoader2">
    <div class="lds-ripple" ><div></div><div></div></div>
    </div>
       <Dashboard/>
        <!-- Main Content -->
        <div class="main-content">
          <section class="section">
            <div class="section-header">
              <h1>Payment History</h1>
              <div class="section-header-breadcrumb">
                <div class="breadcrumb-item active"><router-link to="/dashboard">Home</router-link></div>
                <div class="breadcrumb-item">Payment History</div>
              </div>
            </div>
            <div class="section-body">
              <div class="row">
                <div class="col-12">
                  <div class="card">
                    <div class="card-header d-Fle">
                      <h4 class="hide">Export Table</h4>
                    </div>
                    <div class="card-body">
                      <div class="table-responsive newPc">
                        <table
                          class="table table-bordered table-hover"
                          id="tableExport"
                          style="width: 100%"
                        >
                          <thead>
                            <tr>
                              <th>S No.</th>
                              <th>user Name</th>
                              <th>Parking Name</th>
                              <th>Price/hr</th>
                              <th>Billing amount</th>
                              <th>Admin Commission</th>
                              <th>Transaction Id</th>
                              <th>Payment Mode</th>
                              <th>Date</th>
                              <th>Payment Status</th>
                              <th>Poster Payment Status</th>
                              <th>Booking Status</th>
                              <th>User Refund Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(item,index) in result" :key="item._id">
                              <td>{{index+1}}</td>
                              <td>{{item.requester.name}}</td>
                              <td>{{item.parking_name}}</td>
                              <td>{{item.price}} $</td>
                              <td>{{item.billing_amount}} $</td>
                              <td>{{item.admin_commission}} $</td>
                              <td>{{item.transaction_id.slice(0, 19)}} </td>
                              <td>{{item.payment_mode}}</td>
                              <td>{{item.createdAt.slice(0,10)}} </td>
                              <td>Successful </td>
                              <td>{{ !item.cancel_status?  item.payment_status: "-" }}</td>
                              <td v-if="item.cancel_status==true">Booking Cancelled</td>
                              <td v-else>Booking Successful</td>
                              <td>{{ item.cancel_status? item.payment_status: '-' }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> 
          </section>
        </div>
  </template>
  <script>
  import Dashboard from '@/components/Dashboard.vue'
  import axios from "../services/customAxios";
  import { base_url } from "../config";
  export default{
    name: 'UserManagement',
    components: {
      Dashboard,
    },
    data(){
      return{
        result:[],       
        base_url: base_url,
        showLoader2:true,
      }
    },
    methods:{
      async LoadParking() {
        try{
        let response = await axios.get(`${base_url}/get_all_bookings`); 
        console.log("=====Payment=====>>>>>",response.data.data);
        this.result = response.data.data.reverse();           
      }
      catch (error) {
        if (error) {
          this.showLoader= false;
            this.result = [];
          }
        }
      } 
    },
    async mounted(){
      this.LoadParking();
      let recaptchaScript = document.createElement('script');
      recaptchaScript.setAttribute('src', 'assets/pages/datatables.js');
      setTimeout(() => {
        document.body.appendChild(recaptchaScript)  
        this.showLoader2= false
      }, 4500);  
    }
  };
  </script>
  
  <style>
  .imageSize{
    height: 65px;
    width: 65px;
    margin: 5px 0;
    border: 1px solid rgb(12, 176, 127);
    border-radius: 5px;
  }
  .hide{
    visibility: hidden;
  }
  </style>